import React, { Fragment } from "react";
import { connect } from "react-redux";
import { Table, Popover, Overlay, Modal, Row, Col, Container } from "react-bootstrap";
import PersonView from "./PersonView";
import $ from "jquery";
import ModalPersonRenderer from "./renderers/ModalPersonRenderer";
import StudentController from "../api/StudentController";
import InstructorsView from "./InstructorsView";
import SubjectsPopoverView from "./SubjectsPopoverView";

interface SubjectsTableViewState
{
    target: any;
    show: boolean | undefined;
    popOverData: any;
    showModal: boolean;
    assignmentCount: number;
}

interface SubjectsTableViewProps
{
    class: ClassSubject;
    settings?: any;
    termCode: string;
}

class SubjectsTableView extends React.Component<SubjectsTableViewProps, SubjectsTableViewState>
{
    studentController: StudentController;

    constructor(props: SubjectsTableViewProps) 
    {
        super(props);
        this.studentController = new StudentController();

        this.state = {
            show: false,
            target: false,
            popOverData: null,
            showModal: false,
            assignmentCount: 0
        };
    }

    updateAssignmentCount = (data: number) =>
    {
        this.setState({ assignmentCount: data });
    }

    getSubjectDisplayStatus(statusDescription: string): string
    {
        if (statusDescription.indexOf("--") > -1)
        {
            return statusDescription.split("-- ")[1];
        } else
        {
            return statusDescription;
        }
    }

    render(): React.ReactNode 
    {
        let privacyClass = "";

        if (this.props.settings.length > 0)
            privacyClass = (this.props.role == "academicAdvisor" && this.props.settings.filter(itm => itm.settingId == "psAcademicAssignments")[0].isActive == true) ? "d-none" : "";

        const handleClose = () => this.setState({ showModal: false });
        const handleShow = (itm: any): void =>
        {
            this.setState({ showModal: true });
        };

        return <Fragment>
            <tr>
                <td>{this.props.class.subject}</td>
                <td>{this.props.class.subjectTitle}</td>
                <td>{this.props.class.statusDescription ? this.getSubjectDisplayStatus(this.props.class.statusDescription) : " - "}</td>
                <td><InstructorsView subjectCode={this.props.class.subjectCode} subjectNumber={this.props.class.subjectNumber} termCode={this.props.termCode} /></td>
                <td>{this.props.class.units}</td>
                <td>{this.props.class.grade}</td>
                <td className={privacyClass}><a onClick={(): void => handleShow({})}><i className={"fas fa-info-circle"}></i></a></td>
            </tr>
            <Modal size="xl" aria-labelledby="subject-info-modal" centered show={this.state.showModal} onHide={handleClose}>
                <Modal.Body>
                    <SubjectsPopoverView assignmentCount={this.updateAssignmentCount} class={this.props.class} termCode={this.props.termCode}/>
                </Modal.Body>
            </Modal>
        </Fragment>;
    }
}

const mapStateToProps = (state: any) => ({
    role: state.app.user.role,
    settings: state.app.privacySettings
});

export default connect(mapStateToProps)(SubjectsTableView);